/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An advanced pricing structure
 */
export interface ZzzingServiceAdvancedPricing { 
    default_price?: number;
    price_by_count?: { [key: string]: number; };
}

